module.exports = __webpack_public_path__ + "img/XGqrcode.b939e549.png";